import {Component, Input, OnInit} from '@angular/core';
import {Restaurant, RestaurantProduct} from '../../../../core/models/restaurant.model';
import {ItemService} from '../../../../core/services/item.service';
import {CartStore} from '../../../../core/stores/cart.store';
import {RestaurantStore} from '../../../../core/stores/restaurant.store';
import {IMG_200, IMG_500} from '../../../../core/constants';
import {UtilService} from '../../../../core/services/util.service';
import {ProductModalComponent} from '../../../../shared/components/product-modal/product-modal.component';
import {MenuItemForPayment} from '../../../../core/models/cart-item.model';
import {ModalController, Platform} from '@ionic/angular';
import {getPriceRange, getPriceWithModifiers} from '../../../../core/dto/item.dto';
import {PaymentStore} from '../../../../core/stores/payment.store';
import {OrderApiService} from '../../../../core/services/order.api.service';
import {Order} from '../../../../core/models/payment-item.model';
import {FulfillmentType} from '../../../../core/models/order.model';

@Component({
  selector: 'app-item-suggestions',
  templateUrl: './item-suggestions.component.html',
  styleUrls: ['./item-suggestions.component.scss'],
})
export class ItemSuggestionsComponent implements OnInit {
  @Input() locationId: string;
  @Input() restaurant: Restaurant;
  public restaurantProduct: RestaurantProduct[] = [];
  public currencySign = '$';
  public selectedProduct: RestaurantProduct;
  public isShowProductModal = false;
  public getPriceRange = getPriceRange;
  public getPriceWithModifiers = getPriceWithModifiers;

  constructor(
    private itemService: ItemService,
    private cartStore: CartStore,
    private restaurantStore: RestaurantStore,
    private utilService: UtilService,
    private modalController: ModalController,
    private platform: Platform,
    private paymentStore: PaymentStore,
    private orderApiService: OrderApiService
  ) { }

  public get isMobile(): boolean {
    return this.platform.is('mobile') || this.platform.width() < 600;
  }

  public imageUrl(restaurantProduct: RestaurantProduct): string {
    return this.utilService.getImageUrl(restaurantProduct.info.imageUrl, IMG_200, false);
  }

  public closeProductModal(): void {
    this.isShowProductModal = false;
    this.selectedProduct = null;
  }

  ngOnInit() {
    this.getSuggestionItems();
  }

  public async createModal(product) {
    const modal = await this.modalController.create({
      component: ProductModalComponent,
      componentProps: {
        restaurant: this.restaurant,
        defaultProduct: product,
        locationId: this.locationId,
        isModal: false,
        allowScheduledPickups: this.restaurant.allowScheduledPickups,
        isMobileEnabled: this.restaurant.isMobileEnabled,
        enforceInventory: this.restaurant.enforceInventory,
        hoursOfOperation: this.restaurant.hoursOfOperation,
        currencySign: this.restaurantStore.restaurantCountryInfo.currencySign,
        isClosed: false,
        isRestaurantHaveEnabledWorkDays: true,
      },
    });

    modal.onDidDismiss().then((data) => {
      const item = data['data'] ? data['data'].cartProduct : null;
      if (item) {
        this.onAddItemToCart(item);
      } else {
        this.paymentStore.isWaitingUpdate = false;
      }
    });
    await modal.present();
  }

  public onAddItemToCart(item: MenuItemForPayment): void {
    this.isShowProductModal = false;
    if (!this.cartStore.updateCartInProgress) {
      if (item == null) {
        return;
      }
      this.cartStore.addItemToCart(item);
      this.cartStore.updateCartInProgress = true;
      const order = this.orderApiService.createOrder(item.locationId);
      this.calculateOrder(item.locationId, order);
      this.closeProductModal();
    }
  }

  private calculateOrder(locationId: string, order: Order): void {
    if (this.cartStore.tab) {
      order.is_additional_tab_round = true;
      order.fulfillment_type = FulfillmentType.TABLESIDE;
      order.is_tab_order = true;
    }
    order.ikon_pass_id = this.paymentStore.customer?.ikon_pass_id;
    this.orderApiService.calculateOrder(locationId, order)
      .subscribe(({total_money, taxes, discounts, accumulated_loyalty_points, line_items, estimated_duration}: any) => {
        const totalPrice = total_money.amount - this.cartStore.taxesSum(taxes);
        this.cartStore.updateOrderMapData(locationId, order, totalPrice, taxes, discounts, accumulated_loyalty_points, line_items, estimated_duration);
        this.paymentStore.isWaitingUpdate = false;
        this.cartStore.updateCartInProgress = false;
        this.getSuggestionItems();
      });
  }

  public showProductModal(product: RestaurantProduct) {
    this.selectedProduct = product;
    if (!this.isMobile) {
      this.isShowProductModal = true;
    } else if (!this.restaurantStore.openItemCardInProgress) {
      this.restaurantStore.openItemCardInProgress = true;
      this.createModal(product);
    }
  }

  public getFormattedPrice(price: string | number, quantity = 1): string {
    return (+price * quantity).toFixed(2);
  }

  private get getCartItems(): string[] {
    return this.cartStore.items.map(item => item.itemId);
  }

  private getSuggestionItems(): void {
    this.itemService.getSuggestionItems(this.locationId, this.getCartItems)
      .subscribe(response => {
        this.getItems(response);
      });
  }

  private getItems(suggestionItems: string[]): void {
    this.restaurantStore.curProducts$.subscribe((products: RestaurantProduct[][]) => {
      this.restaurantProduct = [];
      if (products && products.length) {
        products.map(items => {
          items.map(item => {
            if (suggestionItems.some(id => id === item.info.id) && !this.restaurantProduct.some(product => product.info.id === item.info.id)) {
              this.restaurantProduct.push(item);
            }
          });
        });
      }
    });
  }
}
